import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiairportcabs() {



const cardData = {
  keyword: "Pune to Mumbai Airport Cabs",
  heading: "Lotus Cab: Pune to Mumbai Airport Cabs",

  headingDescription:
    "Lotus Cabs provides trusted and affordable Pune to Mumbai Airport Cabs for domestic and international airport transfers, corporate travel, family vacations, student travel, business meetings, and one-way or round-trip journeys. Our fleet includes comfortable Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus options, driven by professional and experienced chauffeurs. With 24x7 booking support, doorstep pickup anywhere in Pune, real-time flight tracking, transparent pricing, well-maintained vehicles, and punctual service via the Mumbai–Pune Expressway, Lotus Cabs ensures a safe, comfortable, and hassle-free airport transfer experience to Mumbai International Airport for every traveler.",

  top: "Major Airport & Route Highlights Covered from Pune",

topPlaces: [
    {
        title: "Bandra",
        description:
            "Bandra is one of Mumbai's most vibrant suburbs, known for premium hotels, shopping streets, Bandstand Promenade, Mount Mary Basilica, and excellent connectivity to Mumbai Airport. Many travelers book Pune to Mumbai Airport cabs with stops in Bandra for business meetings, hotel check-ins, and leisure visits before their flights."
    },
    {
        title: "Juhu",
        description:
            "Juhu is famous for Juhu Beach, luxury hotels, Bollywood residences, and fine dining restaurants. Located close to Mumbai Airport, it is a preferred destination for travelers arriving from Pune who wish to relax, attend business meetings, or stay overnight before catching domestic or international flights."
    },
    {
        title: "Andheri",
        description:
            "Andheri is one of Mumbai's busiest commercial and residential hubs with excellent connectivity to Chhatrapati Shivaji Maharaj International Airport. The area houses corporate offices, business parks, hotels, shopping malls, and entertainment centers, making it a frequent destination for airport cab passengers."
    },
    {
        title: "Powai",
        description:
            "Powai is a modern township known for Powai Lake, Hiranandani Gardens, premium hotels, educational institutions, and IT companies. Its proximity to Mumbai Airport makes it one of the most popular pickup and drop locations for business travelers and corporate executives."
    },
    {
        title: "Bandra Kurla Complex (BKC)",
        description:
            "Bandra Kurla Complex is Mumbai's leading financial and business district, home to multinational corporations, banks, embassies, and convention centers. Corporate travelers frequently choose Pune to Mumbai Airport cab services with convenient drop-offs at BKC before or after their flights."
    },
    {
        title: "Lower Parel",
        description:
            "Lower Parel is a major commercial and lifestyle destination featuring corporate offices, luxury hotels, shopping malls, and entertainment venues. Business professionals traveling between Pune and Mumbai Airport often visit Lower Parel for meetings and corporate events."
    },
    {
        title: "Colaba",
        description:
            "Colaba is one of South Mumbai's most iconic tourist destinations, known for the Gateway of India, Taj Mahal Palace Hotel, Colaba Causeway, and Arabian Sea views. Visitors arriving from Pune frequently explore this heritage district before departing from Mumbai Airport."
    },
    {
        title: "Marine Drive",
        description:
            "Marine Drive is Mumbai's famous seaside boulevard offering spectacular views of the Arabian Sea and the city's skyline. Travelers often include this landmark in their itinerary while visiting Mumbai before heading to the airport."
    },
    {
        title: "Nariman Point",
        description:
            "Nariman Point is a prestigious commercial district overlooking the Arabian Sea and is home to leading corporate offices, luxury hotels, and business centers. It remains a preferred destination for executives traveling from Pune to Mumbai."
    },
    {
        title: "Chhatrapati Shivaji Maharaj International Airport",
        description:
            "Mumbai International Airport is India's second-busiest airport, serving millions of domestic and international passengers every year. Lotus Cabs provides punctual airport transfers with professional chauffeurs, flight tracking, spacious luggage support, and comfortable vehicles, ensuring a smooth and stress-free journey from Pune to the airport."
    }
],

  services: [
    {
      name: "Pune to Mumbai Airport Taxi",
      description:
        "Reliable airport taxi service from Pune to Mumbai Airport with timely pickup. AC sedan and SUV options available. Experienced highway drivers provided. Transparent one-way pricing ensured. Safe and comfortable expressway travel guaranteed."
    },
    {
      name: "Pune to Mumbai Airport One Way Cab",
      description:
        "Affordable one-way airport cab where you pay only for single-side distance. Ideal for flight departures. No return fare charges. Professional drivers ensure punctual arrival. Clean vehicles maintained for long-distance comfort."
    },
    {
      name: "Pune to Mumbai Airport Round Trip Taxi",
      description:
        "Flexible round-trip airport taxi with return scheduling options. Suitable for same-day airport pickup and drop. Transparent fare structure maintained. Comfortable long-distance vehicles provided."
    },
    {
      name: "Luxury Cab Pune to Mumbai Airport",
      description:
        "Premium luxury sedan and SUV options available for executive and VIP airport transfers. Well-maintained vehicles provided. Professional chauffeurs assigned. Ideal for corporate travel."
    },
    {
      name: "SUV Taxi Pune to Mumbai Airport",
      description:
        "Spacious SUV taxi suitable for families and group airport transfers. Extra luggage space available. Comfortable seating ensured. Safe highway travel guaranteed."
    },
    {
      name: "Sedan Cab Pune to Mumbai Airport",
      description:
        "Budget-friendly sedan cab for airport drop and pickup. Ideal for individuals and small families. Clean AC vehicles maintained. Transparent billing policy followed."
    },
    {
      name: "24/7 Airport Transfer Pune to Mumbai",
      description:
        "Round-the-clock airport transfer service available. Night and early morning bookings accepted. Timely arrival guaranteed. Professional drivers ensure safe travel."
    },
    {
      name: "Corporate Airport Taxi Pune to Mumbai",
      description:
        "Specialized corporate airport cab service for business executives. Punctual pickup ensured. Professional drivers assigned. Monthly billing available for companies."
    }
  ],

  tableData: [
    ["Pune to Mumbai Airport Cabs", "Pune to Mumbai Airport Taxi"],
    ["Pune to Mumbai Airport One Way Cab", "Pune to Mumbai Airport Round Trip Taxi"],
    ["Affordable Pune to Mumbai Airport Cab", "Luxury Cab Pune to Mumbai Airport"],
    ["SUV Taxi Pune to Mumbai Airport", "Sedan Cab Pune to Mumbai Airport"],
    ["24/7 Airport Transfer Pune to Mumbai", "Online Airport Cab Booking Pune"],
    ["Corporate Airport Taxi Pune to Mumbai", "Family Airport Cab Pune to Mumbai"],
    ["AC Taxi Pune to Mumbai Airport", "Instant Cab Pune to Mumbai Airport"],
    ["Best Cab Service Pune to Mumbai Airport", ""]
  ],

  whychoose: [
    { WhyChooseheading: "Timely Airport Arrival", WhyChoosedescription: "We ensure early departure planning and punctual airport drop service." },
    { WhyChooseheading: "Experienced Highway Drivers", WhyChoosedescription: "Professional drivers skilled in Mumbai–Pune Expressway travel." },
    { WhyChooseheading: "Transparent Pricing", WhyChoosedescription: "Clear one-way and round-trip fare structure with no hidden charges." },
    { WhyChooseheading: "24/7 Availability", WhyChoosedescription: "Airport taxi service available day and night." },
    { WhyChooseheading: "Comfortable AC Vehicles", WhyChoosedescription: "Well-maintained sedan and SUV fleet provided." },
    { WhyChooseheading: "Corporate Travel Support", WhyChoosedescription: "Executive airport transfer solutions available for companies." },
    { WhyChooseheading: "Safe Long-Distance Travel", WhyChoosedescription: "Safety-first driving with professional chauffeurs." },
    { WhyChooseheading: "Instant Online Booking", WhyChoosedescription: "Quick booking confirmation and responsive customer support." }
  ]
};

const faqData = [
  { question: "Do you provide one-way Pune to Mumbai Airport cab?", answer: "Yes, affordable one-way airport drop services are available." },
  { question: "Is 24/7 airport cab available?", answer: "Yes, we operate round-the-clock airport taxi service." },
  { question: "Are toll charges included?", answer: "Toll charges are informed transparently during booking." },
  { question: "Do you offer corporate airport transfers?", answer: "Yes, corporate airport cab services are available." },
  { question: "Are vehicles AC?", answer: "Yes, all airport taxis are air-conditioned." },
  { question: "Can I book round trip airport taxi?", answer: "Yes, round-trip airport taxi options are available." },
  { question: "How long does travel take?", answer: "Average travel time is 3 to 4 hours depending on traffic." },
  { question: "Are drivers experienced?", answer: "Yes, all drivers are experienced in expressway travel." },
  { question: "Is online booking available?", answer: "Yes, instant online booking is available." },
  { question: "Do you provide SUV airport taxi?", answer: "Yes, SUV options are available for family travel." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Sharma",
    feedback:
      "Booked Pune to Mumbai Airport cab for international flight. Driver arrived early and ensured smooth travel. Highly professional service.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Neha Kulkarni",
    feedback:
      "Very comfortable SUV airport transfer. Transparent pricing and punctual service made our family airport drop stress-free.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client – IT Firm",
    feedback:
      "Our executives frequently use Lotus Cab for Mumbai airport transfers. Reliable service with excellent professionalism.",
    rating: 5
  }
];



































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Cab",
  "image": "https://lotuscab.com/assets/images/pune-to-mumbai-airport-cab.jpg",
  "description":
    "Book Pune to Mumbai Airport Cab with Lotus Cab for affordable, safe, and comfortable airport transfers. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with instant booking confirmation.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-mumbai-airport-cab"
  }
};















  return (
    <div>
      

<Helmet>
  <title>Pune to Mumbai Airport Cab | Mumbai Airport Taxi Service | +91 8767592195</title>

  <meta
    name="description"
    content="Book Pune to Mumbai Airport Cab at affordable fares with Lotus Cab. Reliable airport taxi service with Sedan, SUV, AC cabs, one way & round trip booking, professional drivers, and 24x7 customer support."
  />

  <meta
    name="keywords"
    content="Pune to Mumbai Airport Cab, Pune to Mumbai Airport Taxi, Pune Airport Taxi, Mumbai Airport Cab from Pune, Pune to Chhatrapati Shivaji Maharaj International Airport Cab, Pune to Mumbai Airport One Way Cab, Pune to Mumbai Airport Taxi Service, Airport Taxi Pune, Pune to Mumbai Airport Drop Taxi, Mumbai Airport Transfer from Pune, Best Pune to Mumbai Airport Cab, Cheap Pune to Mumbai Airport Taxi, Online Airport Cab Booking Pune, AC Taxi Pune to Mumbai Airport, Pune Airport Transfer Service, Lotus Cab Pune to Mumbai Airport, Pune to Mumbai Airport Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiairportcabs;